<template>
  <wx-work-list-panel v-loading="!this.$store.state.work.loaded" :work-list="workList" :delivery="delivery">
  </wx-work-list-panel>
</template>

<script>
  import WxWorkListPanel from '@/views/wx/WxWorkListPanel'

  export default {
    name: 'WxWorkList',
    components: {
      WxWorkListPanel
    },
    props: {
      delivery: Boolean
    },
    data () {
      return {}
    },
    methods: {},
    computed: {
      workList () {
        if (!this.$store.state.work.loaded) return []
        const list = []
        list.push.apply(list, this.$store.state.work.beginWork.workList)
        for (const columns of this.$store.state.work.middleWorks) {
          for (const column of columns) {
            list.push.apply(list, column.workList)
          }
        }
        for (const column of this.$store.state.work.endWorks) {
          list.push.apply(list, column.workList)
        }
        return list
      }
    }
  }
</script>
